import { HttpErrorResponse } from '@angular/common/http';
import { MetaData, Promotion } from '@emi/shared/models';
import { createAction, props } from '@ngrx/store';

export const getPromotions = createAction('[PromotionFilters] Get Promotions');

export const getPromotionsSuccess = createAction(
    '[PromotionFilters] Get Promotions Success',
    props<{ promotions: Promotion[]; metadata: MetaData | null; searchText: string | null }>()
);

export const getPromotionsFailure = createAction('[PromotionFilters] Get Promotions Failure', props<{ error: HttpErrorResponse }>());

export const fetchPromotions = createAction('[PromotionFilters] Fetch Promotions');

export const searchPromotions = createAction(
    '[PromotionFilters] Get Promotions With Search',
    props<{ searchText: string; delay: number }>()
);

export const isLoadingPromotions = createAction('[PromotionFilters] Loading Promotions');

export const amendPromotionSelections = createAction('[PromotionFilters] Amend Selected Promotions');
